"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ImageTag = _interopRequireDefault(require("../ImageTag"));
var _IconButton = _interopRequireDefault(require("material-ui/IconButton"));
var _RaisedButton = _interopRequireDefault(require("material-ui/RaisedButton"));
var _modeEdit = _interopRequireDefault(require("material-ui/svg-icons/editor/mode-edit"));
var _crop = _interopRequireDefault(require("material-ui/svg-icons/image/crop"));
var _cloudinaryReact = require("cloudinary-react");
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _delete = _interopRequireDefault(require("material-ui/svg-icons/action/delete"));
require("./AssetListEditor.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var AssetListEditor = /*#__PURE__*/function (_Component) {
  _inherits(AssetListEditor, _Component);
  var _super = _createSuper(AssetListEditor);
  function AssetListEditor(props) {
    var _this;
    _classCallCheck(this, AssetListEditor);
    _this = _super.call(this, props);
    _this.state = {
      currentFrame: 0
    };
    _this.hasImageData = _this.hasImageData.bind(_assertThisInitialized(_this));
    _this.onTimeUpdate = _this.onTimeUpdate.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(AssetListEditor, [{
    key: "hasImageData",
    value: function hasImageData() {
      var cloudPublicId = this.props.cloudPublicId || this.props.value && this.props.value.cloudPublicId;
      var src = this.props.src || this.props.value && this.props.value.src;
      return typeof cloudPublicId !== "undefined" && cloudPublicId || typeof src !== "undefined" && src;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.handleFrameSetterDebounced = (0, _debounce2["default"])(function (time) {
        // const currentTime = time.target.currentTime;
        console.log("handleFrameSetterDebounced - time", time);
        this.onTimeUpdate.apply(this, [time]);
      }, 1000);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      //console.log('[ASSET LIST EDITOR] - this.props', this.props);
      var iconButtonStyle = {
        width: 40,
        height: 40,
        padding: 0
      };
      var iconStyle = {
        width: 24,
        height: 24,
        color: "white"
      };
      var imgStyle = {
        objectFit: this.props.imageFit
      };
      var imgConfig = this.props.config ? this.props.config : this.props.assetConfig ? this.props.assetConfig : {};
      var cloudPublicId = this.props.cloudPublicId || this.props.value && this.props.value.cloudPublicId;
      var cloudName = this.props.cloudName || this.props.value && this.props.value.cloudName;
      var src = this.props.src || this.props.value && this.props.value.src;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "asset-list-editor"
      }, this.props.hasLabel ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "label-container"
      }, this.props.label) : null, this.hasImageData() ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "asset-container",
        style: {
          background: " #eee"
        }
      }, this.props.showButtons ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "actions-container"
      }, typeof this.props.handleEditClick !== "undefined" && this.props.assetType === "image" ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        className: "icon crop",
        onClick: function onClick() {
          _this2.props.handleEditClick(_this2.props);
          if (typeof _this2.props.handleInputChange !== "undefined") {
            _this2.props.handleInputChange(_this2.props.param, _this2.props);
          }
        },
        style: iconButtonStyle,
        disableTouchRipple: true,
        tooltip: "Crop Image",
        tooltipPosition: "bottom-center"
      }, /*#__PURE__*/_react["default"].createElement(_crop["default"], {
        color: "white",
        style: iconStyle
      })) : null, typeof this.props.handleDeleteClick !== "undefined" ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        className: "icon delete",
        onClick: function onClick() {
          _this2.props.handleDeleteClick(_this2.props);
          if (typeof _this2.props.handleInputChange !== "undefined") {
            _this2.props.handleInputChange(_this2.props.param, _this2.props);
          }
        },
        style: iconButtonStyle,
        disableTouchRipple: true,
        tooltip: "Delete",
        tooltipPosition: "bottom-center"
      }, /*#__PURE__*/_react["default"].createElement(_delete["default"], {
        color: "white",
        style: iconStyle
      })) : null) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "gradient-top"
      }), this.props.assetType === "image" ? /*#__PURE__*/_react["default"].createElement("img", {
        src: "".concat(location.protocol, "//res.cloudinary.com/").concat(cloudName, "/image/upload/").concat(imgConfig.cropCoordinates ? "c_crop,h_" + imgConfig.cropCoordinates.height + ",w_" + imgConfig.cropCoordinates.width + ",x_" + imgConfig.cropCoordinates.x + ",y_" + imgConfig.cropCoordinates.y + "/" : "", "f_auto,q_auto,w_").concat(this.props.cloudCropMaxSize, ",c_scale/v1/").concat(cloudPublicId, ".jpg"),
        style: this.props.imgStyle
      }) : this.props.assetType === "pdf" ? /*#__PURE__*/_react["default"].createElement("img", {
        src: "".concat(location.protocol, "//res.cloudinary.com/").concat(cloudName, "/image/upload/").concat(imgConfig.cropCoordinates ? "c_crop,h_" + imgConfig.cropCoordinates.height + ",w_" + imgConfig.cropCoordinates.width + ",x_" + imgConfig.cropCoordinates.x + ",y_" + imgConfig.cropCoordinates.y + "/" : "", "f_auto,q_auto,w_").concat(this.props.cloudCropMaxSize, ",c_scale/v1/").concat(cloudPublicId, ".jpg"),
        style: this.props.imgStyle
      }) : /*#__PURE__*/_react["default"].createElement(_cloudinaryReact.Video, {
        style: {
          width: "100%"
        },
        publicId: cloudPublicId,
        onTimeUpdate: function onTimeUpdate(e) {
          return _this2.handleFrameSetterDebounced(e.target.currentTime);
        },
        cloudName: cloudName,
        controls: true
      })) : /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          textAlign: "center"
        }
      }, /*#__PURE__*/_react["default"].createElement(_RaisedButton["default"], {
        label: "Choose an Asset",
        onClick: function onClick() {
          return _this2.props.handleAddClick(_this2.props);
        }
      })), this.hasImageData() && this.props.assetType === "video" && typeof this.props.handleFrameSetterFunc !== "undefined" ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "set-frame-container",
        style: {
          textAlign: "center",
          marginTop: 10
        }
      }, /*#__PURE__*/_react["default"].createElement(_RaisedButton["default"], {
        label: "Set Frame as Poster",
        onClick: function onClick() {
          return _this2.props.handleFrameSetterFunc(_this2.state.currentFrame);
        }
      })) : null);
    }
  }, {
    key: "onTimeUpdate",
    value: function onTimeUpdate(time) {
      console.log("[onTimeUPdate] time", time);
      this.setState({
        currentFrame: time
      });
    }
  }]);
  return AssetListEditor;
}(_react.Component);
AssetListEditor.defaultProps = {
  imageFit: "contain",
  showButtons: true,
  assetType: "image",
  cloudCropMaxSize: 600
};
AssetListEditor.propTypes = {
  cloudName: _propTypes["default"].string,
  cloudPublicId: _propTypes["default"].string,
  handleFrameSetterFunc: _propTypes["default"].func,
  handleInputChange: _propTypes["default"].func,
  imageFit: _propTypes["default"].string,
  handleEditClick: _propTypes["default"].func,
  handleAddClick: _propTypes["default"].func,
  handleDeleteClick: _propTypes["default"].func,
  showButtons: _propTypes["default"].bool,
  assetType: _propTypes["default"].string
};
var _default = AssetListEditor;
exports["default"] = _default;